import React, { useState } from 'react'
import ActionsAndPopups from './ActionsAndPopups'
import {
  GOATFilter,
  personFilterOptions,
  personPopularity,
  personStatusOptions,
  personTypes,
} from '../Data/PersonStaticData'
import FilterPersonDropdowns from '../Person/SearchPerson/FilterPersonDropdowns'
import FilterstatusDropdown from '../Person/SearchPerson/FilterstatusDropdown'
import Select from 'react-select'
import AutoSuggestionsdataSearch from './Autosuggestionsdata'
import './persons.css'
import { Link } from 'react-router-dom'
import { MdEdit } from 'react-icons/md'
import AdminTag from '../../SearchMovie/AdminTag'
import TfidbTagFilter from '../../SearchMovie/TfidbTagFilter'
function ListPersonsactions(props) {
  const [AutoSuggetions, setAutoSuggetions] = useState([])
  const {
    loadSpinner,
    handlePersonStatus,
    handleReset,
    selectedStatus,
    DesableFilter,
    searchQuery,
    searchListTrue,
    handleFilter,
    handlePersonType,
    selectedPersonType,
    selectedFilterOptions,
    handleFilterOptions,
    isPopSelected,
    editFieldName,
    handleLoadMore,
    displayLoadMore,
    inputmodel,
    handleCancelClick,
    handleSaveClick,
    okButtonDisabled,
    setselectedBulkActionStatus,
    sendPop,
    personsLIst,
    deleteFunction,
    onAddingItem,
    editFunction,
    applyFunction,
    checkedArray,
    setLoadSpinner,
    setSearchQuery,
    setDesableFilter,
    setSearchListTrue,
    handlePersonPopularActive,
    approvePerson,
    ApproveOptionPermission,
    EDitOptionPermission,
    DeleteOptionPermission,
    BulkActionPermission,
    tags,
    setTags,
  } = props
  const deselectAutoSuggestions = () => {
    setSearchListTrue(false)
  }

  const dropdownselectfunction = e => {
    setselectedBulkActionStatus(e.target.value)
  }

  const selectSuggestionlist = e => {
    setSearchQuery(e.target.getAttribute('value'))
    setSearchListTrue(false)
  }

  const showEditPopup = () => sendPop(!isPopSelected)

  const handleSearchQuery = async e => {
    setLoadSpinner(true)
    setSearchQuery(e.target.value)
    if (e.target.value.length > 2) {
      try {
        setDesableFilter(false)
        setSearchListTrue(true)
        const autoSuggestions = await AutoSuggestionsdataSearch(e.target.value)
        // const listOptions = autoSuggestions.personHits.map(item => item.name_En)
        setAutoSuggetions(autoSuggestions.personHits)
      } catch {
        setAutoSuggetions([])
      }
    } else {
      setSearchListTrue(false)
    }

    setLoadSpinner(false)
  }

  return (
    <div onClick={deselectAutoSuggestions}>
      {loadSpinner ? (
        <div className='spinner-container'>
          <div className='loading-spinner'></div>
        </div>
      ) : null}
      <div className='searchDiv'>
        <label>Search:</label>
        <div onClick={deselectAutoSuggestions}>
          <input
            type='text'
            className='form-control'
            value={searchQuery}
            onChange={e => handleSearchQuery(e)}
            disabled={selectedStatus === 'draft'}
          />
        </div>
        {/*  */}
        <div className='selectSuggestionlist'>
          {searchListTrue
            ? AutoSuggetions.length === 0
              ? 'No Data Found'
              : AutoSuggetions.map((item, index) => (
                  <div className='p-3 d-flex justify-content-between' key={index}>
                    <lable value={item.name_En} onClick={selectSuggestionlist} key={index}>
                      {item.name_En}
                    </lable>
                    <Link
                      data-toggle='tooltip'
                      title={'Edit Person'}
                      to={`/editperson?${item.PK}`}
                      target='_blank'
                      className='text-dark'
                    >
                      <span className='border border-1 rounded p-1'>
                        <MdEdit />
                      </span>
                    </Link>
                  </div>
                ))
            : null}
        </div>
      </div>
      <div className='align-items-center d-flex gap-4 '>
        <div className='filtersDiv'>
          <lable>
            <b>Filters</b>
          </lable>
          <div className='m-3'>
            <Select
              options={personFilterOptions}
              isMulti
              value={selectedFilterOptions}
              onChange={handleFilterOptions}
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              isDisabled={selectedStatus === 'draft'}
            />
          </div>{' '}
        </div>
        <FilterPersonDropdowns
          dropdownheading={'Type'}
          dropdownplaceholder={'Select Type'}
          options={personTypes}
          selectedValue={selectedPersonType}
          onChange={handlePersonType}
          selectedStatus={selectedStatus}
        />
        <div className='d-flex gap-4 mt-4'>
          <button
            disabled={DesableFilter || selectedStatus === 'draft'}
            className='btn btn-primary buttonStyle'
            type='button'
            onClick={() => handleFilter(false)}
          >
            {' '}
            filter{' '}
          </button>
          <button
            className='btn btn-primary buttonStyle'
            type='button'
            onClick={() => handleReset()}
          >
            reset{' '}
          </button>{' '}
        </div>{' '}
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <FilterstatusDropdown
          dropdownheading={'Status:'}
          dropdownplaceholder={'Select Status'}
          options={personStatusOptions}
          selectedValue={selectedStatus}
          onChange={handlePersonStatus}
          // selectedStatus={selectedStatus}
        />
        <FilterstatusDropdown
          dropdownheading={'Popular person:'}
          dropdownplaceholder={'Select popular'}
          options={personPopularity}
          selectedValue={props.selectedPopular}
          onChange={event => handlePersonPopularActive(event, 'popular')}
          selectedStatus={selectedStatus}
        />
        <FilterstatusDropdown
          dropdownheading={'Person Active Status:'}
          dropdownplaceholder={'Select Active Status'}
          options={personPopularity}
          selectedValue={props.SelectedActiveorNot}
          onChange={event => handlePersonPopularActive(event, 'active')}
          selectedStatus={selectedStatus}
        />
        <FilterstatusDropdown
          dropdownheading={'GOAT:'}
          dropdownplaceholder={'Select GOAT'}
          options={GOATFilter}
          selectedValue={props.GOAT}
          onChange={event => handlePersonPopularActive(event, 'GOAT')}
          selectedStatus={selectedStatus}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <TfidbTagFilter
          movieFilterBy={tags}
          handleFilterChange={setTags}
          type={'person'}
          setSearchListTrue={setSearchListTrue}
          setDesableFilter={setDesableFilter}
        />
        <AdminTag
          movieFilterBy={tags}
          handleFilterChange={setTags}
          type={'person'}
          label={'Good'}
          setSearchListTrue={setSearchListTrue}
          setDesableFilter={setDesableFilter}
        />
        <AdminTag
          movieFilterBy={tags}
          handleFilterChange={setTags}
          type={'person'}
          label={'Bad'}
          setSearchListTrue={setSearchListTrue}
          setDesableFilter={setDesableFilter}
        />
      </div>
      <ActionsAndPopups
        isPopSelected={isPopSelected}
        editFieldName={editFieldName}
        handleLoadMore={handleLoadMore}
        displayLoadMore={displayLoadMore}
        inputmodel={inputmodel}
        handleCancelClick={handleCancelClick}
        handleSaveClick={handleSaveClick}
        okButtonDisabled={okButtonDisabled}
        showEditPopup={showEditPopup}
        sendPop={sendPop}
        personsLIst={personsLIst}
        deleteFunction={deleteFunction}
        onAddingItem={onAddingItem}
        editFunction={editFunction}
        applyFunction={applyFunction}
        checkedArray={checkedArray}
        dropdownselectfunction={dropdownselectfunction}
        selectedStatus={selectedStatus}
        approvePerson={approvePerson}
        ApproveOptionPermission={ApproveOptionPermission}
        EDitOptionPermission={EDitOptionPermission}
        DeleteOptionPermission={DeleteOptionPermission}
        BulkActionPermission={BulkActionPermission}
      />
    </div>
  )
}

export default ListPersonsactions
